<template>
  <input-field
    type="email"
    :label="label || $t('authenticationUserIdLabel')"
    v-bind="$attrs"
    v-on:input="$emit('input', $event)"
  >
    <template v-slot:accessory>
      <slot name="accessory" />
    </template>
  </input-field>
</template>

<script>
  import InputField from './InputField.vue';

  export default {
    name: 'InputEmailField',
    inheritAttrs: false,
    props: {
      label: String,
    },
    components: {
      InputField,
    }
  }
</script>
